import React, { useState, useEffect } from 'react'; 
// import { useInView } from 'react-intersection-observer'; // REMOVED

// =======================================================================================
// PART 1: IMAGE IMPORTS (Restored)
// =======================================================================================

// Original Imports (Used for the 4 'featurePoints' - assuming .jpg is the format)
import DesignInnovationImage from '../../../assets/Images/ServicesImage1.png';
import ClientJourneyImage from '../../../assets/Images/OtherImage1.png';
import SustainabilityImage from '../../../assets/Images/OtherImage2.png'; // Placeholder
import ExecutionImage from '../../../assets/Images/OtherImage3.png';     // Placeholder

// New Imports for the 4 Services Sections 
import Interior5 from '../../../assets/Images/OtherImage4.png';
import Interior6 from '../../../assets/Images/OtherImage5.png';
import Interior7 from '../../../assets/Images/OtherImage6.png';
import Interior8 from '../../../assets/Images/OtherImage7.png';

// Grouping imported images for sequential assignment in servicesData
const serviceImages = [
    Interior5, Interior6, Interior7, Interior8
];

let imageIndex = 0;
const getNextImage = () => {
    const img = serviceImages[imageIndex % serviceImages.length];
    imageIndex++;
    return img;
};

// =======================================================================================
// PART 2: DATA DEFINITION (Restored)
// =======================================================================================

// --- A. Original 'Why Choose Us' Points (4 items) ---
const featurePoints = [
    {
        title: 'The Art of Design Innovation',
        description: 'We go beyond basic decorating to create living environments that are both beautiful and highly functional. Our design process integrates the latest trends with timeless principles, ensuring a space that feels fresh today and endures for years to come.',
        imageUrl: DesignInnovationImage,
        align: 'left',
        takeaways: [
            { icon: 'fas fa-palette', text: 'Curated Color & Material Palettes' },
            { icon: 'fas fa-lightbulb', text: 'Smart & Ambient Lighting Plans' },
            { icon: 'fas fa-ruler-combined', text: 'Expert Space Planning' }
        ]
    },
    {
        title: 'Your Design Journey Partner',
        description: "Your vision is our blueprint. We pride ourselves on a collaborative, transparent client experience. From concept sketches to the final installation, we manage every detail, making the complex process of interior design seamless and stress free for you.",
        imageUrl: ClientJourneyImage,
        align: 'right',
        takeaways: [
            { icon: 'fas fa-calendar-check', text: 'On Time Project Delivery' },
            { icon: 'fas fa-handshake', text: 'Transparent Budgeting' },
            { icon: 'fas fa-tools', text: 'Managed Vendor & Contractor Network' }
        ]
    },
    {
        title: 'Ethos of Sustainability',
        description: "Conscious design means making choices that benefit both you and the planet. We specialize in sourcing non toxic, sustainable materials and promoting timeless design that reduces the need for frequent replacements, ensuring your investment is responsible and enduring.",
        imageUrl: SustainabilityImage,
        align: 'left',
        takeaways: [
            { icon: 'fas fa-leaf', text: 'Eco Friendly Material Sourcing' },
            { icon: 'fas fa-globe', text: 'Timeless, Waste Reducing Design' },
            { icon: 'fas fa-wind', text: 'Improved Indoor Air Quality' }
        ]
    },
    {
        title: 'Meticulous Project Execution',
        description: "Design is only as good as its execution. We provide robust project management, working closely with elite contractors and artisans to ensure every detail from custom millwork to final decor placement is realized with flawless craftsmanship.",
        imageUrl: ExecutionImage,
        align: 'right',
        takeaways: [
            { icon: 'fas fa-star', text: 'Flawless Finish & Quality Control' },
            { icon: 'fas fa-sitemap', text: 'Advanced 3D Modeling & Plans' },
            { icon: 'fas fa-truck-loading', text: 'White-Glove Installation' }
        ]
    },
];

// --- B. New Services Data (4 main sections with sub-services) ---
export const servicesData = [
    {
        title: 'Residential Interior Design',
        description: 'Creating comfortable, stylish, and functional residential spaces tailored to individual lifestyles, including comprehensive space planning and color selection. From apartments to villas, we craft homes that truly reflect you.',
        imageUrl: getNextImage(), // Interior5.jpg
        align: 'left', // Swapped align to alternate with previous section
        takeaways: [
            { icon: 'fas fa-couch', text: 'Designer for Residence' },
            { icon: 'fas fa-building', text: 'Designer for Apartment' },
            { icon: 'fas fa-home', text: 'Designer for Villa' },
            { icon: 'fas fa-church', text: 'Designer for Puja Room' },
        ],
        subServices: [
            { title: 'Interior Designer for Residence', description: 'Creating comfortable, stylish, and functional residential spaces tailored to individual lifestyles, including space planning and color selection.', icon: 'fas fa-home' },
            { title: 'Interior Designer for Apartment', description: 'Optimizing space utilization, aesthetics, and functionality in apartments using personalized layouts, smart storage, and modern trends.', icon: 'fas fa-building' },
            { title: 'Interior Designer for Villa', description: 'Specializing in luxurious and personalized living spaces with comprehensive layout planning, high-quality materials, and advanced home technologies.', icon: 'fas fa-house-user' },
            { title: 'Interior Designer for Puja Room', description: 'Creating serene, sacred spaces with proper lighting, ventilation, and traditional elements aligned with Vastu principles.', icon: 'fas fa-church' },
            { title: 'Interior Designer for Home Office', description: 'Creating productive, ergonomic, and aesthetically pleasing home workspaces with functional furniture and smart storage.', icon: 'fas fa-briefcase' },
            { title: 'Interior Designer for Study Room', description: 'Creating functional and inspiring study spaces with ergonomic furniture, appropriate lighting, and storage solutions.', icon: 'fas fa-book' },
            { title: 'Interior Designer for Bathroom', description: 'Emphasizing luxury, efficiency, and functionality using premium, waterproof materials, smart space utilization, and spa-inspired elements.', icon: 'fas fa-bath' },
            { title: 'Interior Designer for Door', description: 'Selecting and designing doors and hardware (handles, locks, hinges) that complement the overall interior aesthetic and functional requirements.', icon: 'fas fa-door-closed' },
            { title: 'Interior Designer for Staircase', description: 'Transforming stairways using materials like wood, glass, or marble, and designing handrails, balustrades, and lighting for safety and visual appeal.', icon: 'fas fa-shoe-prints' },
            { title: 'Interior Designer for Ceiling & PVC', description: 'Designing and treating ceilings with various materials, textures, and architectural elements, including specialized PVC ceiling panels, to enhance the ambiance.', icon: 'fas fa-skyatlas' },
            { title: 'Interior Decorator for Cabin', description: 'Designing cozy, functional work or leisure cabins using warm textures, ergonomic furniture, and space-saving layouts.', icon: 'fas fa-mountain' },
            { title: 'Eco Friendly Interior Designer', description: 'Focusing on sustainable spaces using renewable, recycled, or low-impact materials and prioritizing energy efficiency.', icon: 'fas fa-leaf' },
            { title: 'Korean Interior Designer', description: 'Incorporating Korean aesthetics, emphasizing simplicity, harmony, natural materials, and minimalistic layouts.', icon: 'fas fa-globe-asia' },
            { title: 'Interior Designer Consultants', description: 'Providing expert guidance on space planning, decor, material selection, layout optimization, and budget management.', icon: 'fas fa-clipboard-list' },
        ]
    },
    {
        title: 'Commercial & Corporate Interior Design',
        description: 'Designing productive and aesthetically pleasing environments for businesses. We focus on strategic space planning to enhance work atmosphere, collaboration, and brand identity for offices, retail, and hospitality.',
        imageUrl: getNextImage(), // Interior6.jpg
        align: 'right',
        takeaways: [
            { icon: 'fas fa-industry', text: 'Corporate Space Planning' },
            { icon: 'fas fa-store-alt', text: 'Retail Environment Creation' },
            { icon: 'fas fa-handshake', text: 'Business Interior Architecture' }
        ],
        subServices: [
            { title: 'Commercial Space Designers', description: 'Creating functional and aesthetically pleasing environments for businesses, including offices, retail stores, and hotels, maximizing space efficiency.', icon: 'fas fa-city' },
            { title: 'Business Interior Architecture', description: 'Strategic planning and design of commercial interiors to enhance the work atmosphere, productivity, and brand identity.', icon: 'fas fa-ruler-triangle' },
            { title: 'Corporate Space Planning Services', description: 'Strategic design and organization of office environments to enhance productivity, collaboration, and employee well-being.', icon: 'fas fa-drafting-compass' },
            { title: 'Enterprise Interior Design Solutions', description: 'Comprehensive design services for corporate spaces, focusing on functionality, aesthetics, and efficiency.', icon: 'fas fa-building' },
            { title: 'Retail Interior Environment Creation', description: 'Designing retail spaces to enhance customer experience, drive sales, and reflect the brand\'s identity through layout and lighting.', icon: 'fas fa-store' },
            { title: 'Interior Decorators For Office & Communication Centre', description: 'Creating functional and aesthetically pleasing workspaces that enhance productivity and employee satisfaction, reflecting the company\'s identity and fostering collaboration.', icon: 'fas fa-users' },
            { title: 'Club House & Hotel Interior Decorators', description: 'Transforming clubhouses and hotel spaces into inviting, stylish, and luxurious environments for social interaction, relaxation, and guest experience.', icon: 'fas fa-wine-glass-alt' },
        ]
    },
    {
        title: 'Professional Painting & Artistic Services',
        description: 'Transforming spaces with color and artistry. Our painting services cover all surfaces interior, exterior, wood, and metal using high quality, durable materials. We also offer specialized mural and hand painting artistry.',
        imageUrl: getNextImage(), // Interior7.jpg
        align: 'left',
        takeaways: [
            { icon: 'fas fa-fill-drip', text: 'High Quality Interior & Exterior Finishes' },
            { icon: 'fas fa-brush', text: 'Specialized Artistry & Mural Work' },
            { icon: 'fas fa-toolbox', text: 'Wood, Metal & Equipment Painting' }
        ],
        subServices: [
            { title: 'Interior Wall Painting (General)', description: 'Professional solutions for transforming spaces with color, including surface preparation, precise application, and cleanup.', icon: 'fas fa-spray-can' },
            { title: 'Living Room Wall Painting', description: 'Professional painting, color consultations, and high-quality materials to create a warm and inviting atmosphere.', icon: 'fas fa-chair' },
            { title: 'Bed Room Wall Painting', description: 'Surface preparation, patching imperfections, primer application, and optional accent walls for a smooth, stylish finish.', icon: 'fas fa-bed' },
            { title: 'Kitchen Wall Painting', description: 'Uses high-quality, durable paints that withstand moisture and stains for a long-lasting, vibrant finish.', icon: 'fas fa-utensils' },
            { title: 'Bathroom Wall Painting', description: 'Uses moisture-resistant paints for a durable finish that withstands humidity and daily wear.', icon: 'fas fa-shower' },
            { title: 'Dining Room Wall Painting', description: 'Creates a welcoming ambiance through color selection, surface preparation, and precise painting techniques.', icon: 'fas fa-bread-slice' },
            { title: 'Exterior Wall Painting', description: 'Includes texture application, decorative finishes, and environmentally friendly paint choices, focusing on durability and longevity.', icon: 'fas fa-tree-city' },
            { title: 'Wood Painting', description: 'Applying protective and decorative finishes to wooden surfaces (furniture, doors, cabinets) to enhance beauty and durability.', icon: 'fas fa-door-open' },
            { title: 'Metal Painting', description: 'Expert application of high-quality, rust-resistant paints to metal surfaces (railings, furniture, fixtures) for durability and aesthetics.', icon: 'fas fa-cogs' },
            { title: 'Chimney Painting Services', description: 'Applying high-quality, weather-resistant paint, including meticulous preparation and priming, to enhance aesthetic appeal and longevity.', icon: 'fas fa-smog' },
            { title: 'Construction Equipment Painting Services', description: 'High-quality painting solutions for construction machinery to protect against environmental conditions, rust, and wear, maintaining asset value.', icon: 'fas fa-truck-monster' },
            { title: 'Acrylic Painting Services (Custom Art)', description: 'Customized art creation, including stunning abstract pieces, realistic portraits, or mural installations for various spaces.', icon: 'fas fa-pencil-ruler' },
            { title: 'Kerala Mural Hand Painting Job Works', description: 'Traditional Kerala mural painting services for custom designs reflecting Indian mythology and culture, bringing elegance and character to any environment.', icon: 'fas fa-feather-alt' },
            { title: 'Hand Painting On Fabric (Cotton & Artificial)', description: 'Skilled artisans apply intricate designs, patterns, and colors directly onto various fabrics for custom fashion or home decor.', icon: 'fas fa-tshirt' },
            { title: 'Painting Contractor Heritage Surface', description: 'General interior and exterior painting, drywall repair, and surface preparation, including specialized work on heritage properties.', icon: 'fas fa-hammer' },
            { title: 'Commercial Artists & Statue Painting', description: 'Creating visual content for advertisements, branding, and promotional materials, alongside expert artistry to enhance the aesthetic appeal and durability of statues.', icon: 'fas fa-ad' },
        ]
    },
    {
        title: 'Furniture Design & Specialized Contracting',
        description: 'Bespoke furniture creation and expert contracting for specialized interior components. This includes custom bed design, precision wood cutting, and installation services for ceilings and PVC elements.',
        imageUrl: getNextImage(), // Interior8.jpg
        align: 'right',
        takeaways: [
            { icon: 'fas fa-th-large', text: 'Interior & PVC Contracting' },
            { icon: 'fas fa-cut', text: 'Precision Multiwood Cutting' },
            { icon: 'fas fa-bed', text: 'Custom Bed Design & Creation' }
        ],
        subServices: [
            { title: 'Bed Design & Creation', description: 'Custom crafting of unique and personalized beds, including headboards and frames, tailored for aesthetics and comfort.', icon: 'fas fa-bed' },
            { title: 'Multiwood Design Cutting Services', description: 'Precision cutting solutions for various wood types and designs, utilizing advanced machinery for custom furniture and decorative elements.', icon: 'fas fa-tools' },
            { title: 'Interior Contracting Services', description: 'Planning, design, and execution of comprehensive interior renovations, remodeling, and construction projects.', icon: 'fas fa-hard-hat' },
            { title: 'PVC Interior & False Ceiling Services', description: 'Specialized installation and repair for durable, moisture-resistant PVC materials used in wall paneling and ceiling designs.', icon: 'fas fa-layer-group' },
            { title: 'Steel Connection Designers', description: 'Creating efficient and robust connections between structural steel components for construction projects.', icon: 'fas fa-cubes' },
            { title: 'Souvenir Designers (Customised)', description: 'Creating unique and memorable keepsakes capturing the essence of a place or event.', icon: 'fas fa-gifts' }
        ]
    }
];

// =======================================================================================
// PART 3: REACT COMPONENT DEFINITIONS (Fixed and Enhanced)
// =======================================================================================

/**
 * Sub-component for individual feature points to handle animations.
 */
const FeaturePoint = ({ title, description, imageUrl, align, takeaways, subServices }) => {
    // --- REMOVED useInView hook ---
    
    const isRight = align === 'right';

    // --- REMOVED inView and notInView animation classes ---

    return (
        <div
            // --- REMOVED ref={ref} ---
            className={`
                md:grid md:grid-cols-2 md:gap-10 md:gap-16 md:items-center
                transition-all duration-300 ease-in-out
                hover:shadow-2xl hover:scale-[1.01]
                p-4 md:p-8 rounded-3xl -m-4 md:-m-8 
            `}
        >
            {/* --- Image Column (Static load) --- */}
            <div
                className={`
                    relative 
                    ${isRight ? 'md:order-last' : ''} 
                `}
            >
                {/* Background Animation */}
                {/* --- REMOVED inView logic, classes simplified to resting state --- */}
                <div className={`absolute -inset-4 bg-gradient-to-br from-red-100 to-pink-100 rounded-3xl ${isRight ? '-rotate-2' : 'rotate-2'}`}></div>
                
                {/* --- REMOVED inView logic, classes simplified to resting state --- */}
                <div className={`relative rounded-2xl shadow-2xl overflow-hidden transition-transform duration-700 group`}>
                    <img
                        src={imageUrl}
                        alt={title}
                        className="object-cover w-full h-[28rem] md:h-96 transition-transform duration-500 group-hover:scale-105"
                    />
                </div>
            </div>

            {/* --- Text Column (Static load) --- */}
            <div
                className={`
                    relative bg-white p-8 -mt-24 mx-4 rounded-2xl shadow-2xl
                    md:bg-transparent md:shadow-none md:p-0 md:mt-0 md:mx-0
                    
                `}
            >
                {/* --- REMOVED inView logic from h3 --- */}
                <h3 className={`text-2xl md:text-3xl font-bold text-red-700 mb-4`}>{title}</h3>
                
                {/* --- REMOVED inView logic from p --- */}
                <p className={`text-base md:text-lg text-gray-700 leading-relaxed`}>{description}</p>

                {/* Main Takeaways (Static load) */}
                <ul className="mt-6 space-y-4">
                    {takeaways.map((item, index) => (
                        <li
                            key={item.text}
                            // --- REMOVED inView logic from className ---
                            className={`flex items-start`}
                            // --- REMOVED style prop for transitionDelay ---
                        >
                            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-500 text-white flex items-center justify-center">
                                <i className={item.icon}></i>
                            </div>
                            <span className="ml-4 font-semibold text-gray-800">{item.text}</span>
                        </li>
                    ))}
                </ul>

                {/* Sub-Services */}
                {subServices && (
                    <div className="mt-8 pt-4 border-t border-red-100">
                        <h4 className="text-xl font-bold text-gray-800 mb-3">Service Details:</h4>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                            {subServices.slice(0, 6).map((sub, index) => ( 
                                <div
                                    key={sub.title}
                                    // --- REMOVED transition classes ---
                                    className={`flex items-center`}
                                    // --- REMOVED style prop for transitionDelay ---
                                >
                                    <i className={`${sub.icon} text-red-500 text-sm mr-2`}></i>
                                    <span className="text-sm text-gray-600 font-medium">{sub.title}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};


/**
 * Main Component: Combines the Why Choose Us features and the detailed Services.
 */
function DesignFeaturesAndServices() {
    // --- Typewriter State & Logic for Main Headline ---
    const [typedText, setTypedText] = useState('');
    const [showCursor, setShowCursor] = useState(true);
    
    const fullHeadline = "Crafting Innovative Solutions."; // The full text to type
    const typingSpeed = 75; // milliseconds per character

    useEffect(() => {
        let currentText = '';
        let index = 0;
        
        const timer = setInterval(() => {
            if (index < fullHeadline.length) {
                currentText += fullHeadline[index];
                setTypedText(currentText);
                index++;
            } else {
                clearInterval(timer);
                // Keep cursor visible after typing is complete
            }
        }, typingSpeed);

        const cursorTimer = setInterval(() => {
             if (index >= fullHeadline.length) {
                setShowCursor(prev => !prev);
             }
        }, 750);

        return () => {
            clearInterval(timer);
            clearInterval(cursorTimer);
        };
    }, [fullHeadline]);
    // --- End Typewriter Effect Logic ---
    
    // --- Custom Styles for Typewriter and Mobile Fix ---
    const TypewriterStyles = () => (
        <style>{`
          /* Cursor Style */
          .typewriter-cursor {
              border-right: 3px solid #333; 
              animation: blink-caret 0.75s step-end infinite;
          }
          @keyframes blink-caret {
              from, to { border-color: transparent }
              50% { border-color: #333; }
          }
          
          /* Headline container styles for the effect */
          .typewriter-headline-container {
              display: inline-block; 
              white-space: nowrap; /* Crucial for desktop typing effect */
              overflow: hidden; /* Hides text not yet typed */
              margin-right: 5px; /* Space for the cursor */
          }
          
          /* 🌟 CRITICAL MOBILE FIX: Force text wrapping and reduce font size on small screens */
          @media (max-width: 639px) { 
              .typewriter-headline-container {
                  white-space: normal; /* THIS ENABLES TEXT WRAPPING (Fixes overflow) */
                  overflow: visible; /* Allows wrapped content to be displayed */
                  width: 100%; /* Ensure it uses full width for wrapping */
              }
              /* Optional: Reduce font size further for tiny phones */
              .text-3xl.md\\:text-5xl {
                   font-size: 1.75rem !important;
              }
          }
        `}</style>
    );

    return (
        <>
            <TypewriterStyles /> {/* Inject the custom styles */}
            
            <section className="bg-gray-50 py-20 overflow-x-hidden relative"> 
                
                {/* 💡 NEW: The barely noticeable slanted red tint overlay */}
                <div 
                    className="
                        fixed inset-0 z-0 pointer-events-none 
                        bg-[conic-gradient(at_top_right,_var(--tw-gradient-stops))] 
                        from-transparent via-red-200/5 to-transparent
                        animate-slanted-bg
                        opacity-50
                    "
                    style={{
                        // This creates the actual "slanted" gradient effect
                        backgroundSize: '400% 400%', 
                        backgroundAttachment: 'fixed'
                    }}
                ></div>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10"> {/* z-10 to keep content above overlay */}

                    {/* SECTION 1: CORE VALUE PROPOSITION */}
                    <div className="text-center mb-20">
                        {/* --- IMPLEMENTED TYPEWRITER EFFECT HERE --- */}
                        <h2 
                            className="
                                text-3xl md:text-5xl font-extrabold text-gray-900 
                                swing-shake 
                                hover:text-red-600 cursor-default
                            "
                        >
                            <span className="typewriter-headline-container">
                                {typedText}
                                {showCursor && <span className="typewriter-cursor"></span>}
                            </span>
                        </h2>
                        {/* --- END TYPEWRITER IMPLEMENTATION --- */}
                        
                        <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-600">
                            We don't just furnish rooms. We craft personal sanctuaries that elevate daily life.
                        </p>
                    </div>

                    <div className="space-y-24">
                        {featurePoints.map((point) => (
                            <FeaturePoint key={point.title} {...point} />
                        ))}
                    </div>

                    {/* SECTION 2: DETAILED SERVICES */}
                    <div className="text-center mt-32 mb-20">
                        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900">Our Comprehensive Service Portfolio</h2>
                        <p className="mt-4 max-w-3xl mx-auto text-xl text-gray-600">
                            From conceptual interior design to specialized painting and custom contracting, we cover every detail of your project.
                        </p>
                    </div>

                    <div className="space-y-24">
                        {servicesData.map((service) => (
                            <FeaturePoint key={service.title} {...service} />
                        ))}
                    </div>

                </div>
            </section>
        </>
    );
}

export default DesignFeaturesAndServices;